import React from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";

const FeatherIcons = () => {
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Feather Icon</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Feather Icon</li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            {/* Chart */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">Feather Icon</div>
                </div>
                <div className="card-body">
                  <div className="icons-items">
                    <ul className="icons-list">
                      <li>
                        <FeatherIcon icon="activity" />
                      </li>
                      <li>
                        <FeatherIcon icon="airplay" />
                      </li>
                      <li>
                        <FeatherIcon icon="alert-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="alert-octagon" />
                      </li>
                      <li>
                        <FeatherIcon icon="alert-triangle" />
                      </li>
                      <li>
                        <FeatherIcon icon="align-center" />
                      </li>
                      <li>
                        <FeatherIcon icon="align-justify" />
                      </li>
                      <li>
                        <FeatherIcon icon="align-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="align-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="anchor" />
                      </li>
                      <li>
                        <FeatherIcon icon="aperture" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-down-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-down-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-down-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-left-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-right-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-up-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-up-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="arrow-up-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="at-sign" />
                      </li>
                      <li>
                        <FeatherIcon icon="award" />
                      </li>
                      <li>
                        <FeatherIcon icon="bar-chart" />
                      </li>
                      <li>
                        <FeatherIcon icon="bar-chart-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="battery" />
                      </li>
                      <li>
                        <FeatherIcon icon="battery-charging" />
                      </li>
                      <li>
                        <FeatherIcon icon="bell" />
                      </li>
                      <li>
                        <FeatherIcon icon="bell-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="bluetooth" />
                      </li>
                      <li>
                        <FeatherIcon icon="bold" />
                      </li>
                      <li>
                        <FeatherIcon icon="book" />
                      </li>
                      <li>
                        <FeatherIcon icon="book-open" />
                      </li>
                      <li>
                        <FeatherIcon icon="bookmark" />
                      </li>
                      <li>
                        <FeatherIcon icon="box" />
                      </li>
                      <li>
                        <FeatherIcon icon="briefcase" />
                      </li>
                      <li>
                        <FeatherIcon icon="calendar" />
                      </li>
                      <li>
                        <FeatherIcon icon="camera" />
                      </li>
                      <li>
                        <FeatherIcon icon="camera-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="cast" />
                      </li>
                      <li>
                        <FeatherIcon icon="check" />
                      </li>
                      <li>
                        <FeatherIcon icon="check-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="check-square" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevron-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevron-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevron-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevron-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevrons-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevrons-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevrons-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="chevrons-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="chrome" />
                      </li>
                      <li>
                        <FeatherIcon icon="circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="clipboard" />
                      </li>
                      <li>
                        <FeatherIcon icon="clock" />
                      </li>
                      <li>
                        <FeatherIcon icon="cloud" />
                      </li>
                      <li>
                        <FeatherIcon icon="cloud-drizzle" />
                      </li>
                      <li>
                        <FeatherIcon icon="cloud-lightning" />
                      </li>
                      <li>
                        <FeatherIcon icon="cloud-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="cloud-rain" />
                      </li>
                      <li>
                        <FeatherIcon icon="cloud-snow" />
                      </li>
                      <li>
                        <FeatherIcon icon="code" />
                      </li>
                      <li>
                        <FeatherIcon icon="codepen" />
                      </li>
                      <li>
                        <FeatherIcon icon="command" />
                      </li>
                      <li>
                        <FeatherIcon icon="compass" />
                      </li>
                      <li>
                        <FeatherIcon icon="copy" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-down-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-down-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-left-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-left-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-right-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-right-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-up-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="corner-up-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="cpu" />
                      </li>
                      <li>
                        <FeatherIcon icon="credit-card" />
                      </li>
                      <li>
                        <FeatherIcon icon="crop" />
                      </li>
                      <li>
                        <FeatherIcon icon="crosshair" />
                      </li>
                      <li>
                        <FeatherIcon icon="database" />
                      </li>
                      <li>
                        <FeatherIcon icon="delete" />
                      </li>
                      <li>
                        <FeatherIcon icon="disc" />
                      </li>
                      <li>
                        <FeatherIcon icon="dollar-sign" />
                      </li>
                      <li>
                        <FeatherIcon icon="download" />
                      </li>
                      <li>
                        <FeatherIcon icon="download-cloud" />
                      </li>
                      <li>
                        <FeatherIcon icon="droplet" />
                      </li>
                      <li>
                        <FeatherIcon icon="edit" />
                      </li>
                      <li>
                        <FeatherIcon icon="edit-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="edit-3" />
                      </li>
                      <li>
                        <FeatherIcon icon="external-link" />
                      </li>
                      <li>
                        <FeatherIcon icon="eye" />
                      </li>
                      <li>
                        <FeatherIcon icon="eye-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="facebook" />
                      </li>
                      <li>
                        <FeatherIcon icon="fast-forward" />
                      </li>
                      <li>
                        <FeatherIcon icon="feather" />
                      </li>
                      <li>
                        <FeatherIcon icon="file" />
                      </li>
                      <li>
                        <FeatherIcon icon="file-minus" />
                      </li>
                      <li>
                        <FeatherIcon icon="file-plus" />
                      </li>
                      <li>
                        <FeatherIcon icon="file-text" />
                      </li>
                      <li>
                        <FeatherIcon icon="film" />
                      </li>
                      <li>
                        <FeatherIcon icon="filter" />
                      </li>
                      <li>
                        <FeatherIcon icon="flag" />
                      </li>
                      <li>
                        <FeatherIcon icon="folder" />
                      </li>
                      <li>
                        <FeatherIcon icon="folder-minus" />
                      </li>
                      <li>
                        <FeatherIcon icon="folder-plus" />
                      </li>
                      <li>
                        <FeatherIcon icon="git-branch" />
                      </li>
                      <li>
                        <FeatherIcon icon="git-commit" />
                      </li>
                      <li>
                        <FeatherIcon icon="git-merge" />
                      </li>
                      <li>
                        <FeatherIcon icon="git-pull-request" />
                      </li>
                      <li>
                        <FeatherIcon icon="github" />
                      </li>
                      <li>
                        <FeatherIcon icon="gitlab" />
                      </li>
                      <li>
                        <FeatherIcon icon="globe" />
                      </li>
                      <li>
                        <FeatherIcon icon="grid" />
                      </li>
                      <li>
                        <FeatherIcon icon="hard-drive" />
                      </li>
                      <li>
                        <FeatherIcon icon="hash" />
                      </li>
                      <li>
                        <FeatherIcon icon="headphones" />
                      </li>
                      <li>
                        <FeatherIcon icon="heart" />
                      </li>
                      <li>
                        <FeatherIcon icon="help-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="home" />
                      </li>
                      <li>
                        <FeatherIcon icon="image" />
                      </li>
                      <li>
                        <FeatherIcon icon="inbox" />
                      </li>
                      <li>
                        <FeatherIcon icon="info" />
                      </li>
                      <li>
                        <FeatherIcon icon="instagram" />
                      </li>
                      <li>
                        <FeatherIcon icon="italic" />
                      </li>
                      <li>
                        <FeatherIcon icon="layers" />
                      </li>
                      <li>
                        <FeatherIcon icon="layout" />
                      </li>
                      <li>
                        <FeatherIcon icon="life-buoy" />
                      </li>
                      <li>
                        <FeatherIcon icon="link" />
                      </li>
                      <li>
                        <FeatherIcon icon="link-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="linkedin" />
                      </li>
                      <li>
                        <FeatherIcon icon="list" />
                      </li>
                      <li>
                        <FeatherIcon icon="loader" />
                      </li>
                      <li>
                        <FeatherIcon icon="lock" />
                      </li>
                      <li>
                        <FeatherIcon icon="log-in" />
                      </li>
                      <li>
                        <FeatherIcon icon="log-out" />
                      </li>
                      <li>
                        <FeatherIcon icon="mail" />
                      </li>
                      <li>
                        <FeatherIcon icon="map" />
                      </li>
                      <li>
                        <FeatherIcon icon="map-pin" />
                      </li>
                      <li>
                        <FeatherIcon icon="maximize" />
                      </li>
                      <li>
                        <FeatherIcon icon="maximize-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="menu" />
                      </li>
                      <li>
                        <FeatherIcon icon="message-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="message-square" />
                      </li>
                      <li>
                        <FeatherIcon icon="mic" />
                      </li>
                      <li>
                        <FeatherIcon icon="mic-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="minimize" />
                      </li>
                      <li>
                        <FeatherIcon icon="minimize-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="minus" />
                      </li>
                      <li>
                        <FeatherIcon icon="minus-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="minus-square" />
                      </li>
                      <li>
                        <FeatherIcon icon="monitor" />
                      </li>
                      <li>
                        <FeatherIcon icon="moon" />
                      </li>
                      <li>
                        <FeatherIcon icon="more-horizontal" />
                      </li>
                      <li>
                        <FeatherIcon icon="more-vertical" />
                      </li>
                      <li>
                        <FeatherIcon icon="move" />
                      </li>
                      <li>
                        <FeatherIcon icon="music" />
                      </li>
                      <li>
                        <FeatherIcon icon="navigation" />
                      </li>
                      <li>
                        <FeatherIcon icon="navigation-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="octagon" />
                      </li>
                      <li>
                        <FeatherIcon icon="package" />
                      </li>
                      <li>
                        <FeatherIcon icon="paperclip" />
                      </li>
                      <li>
                        <FeatherIcon icon="pause" />
                      </li>
                      <li>
                        <FeatherIcon icon="pause-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="percent" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone-call" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone-forwarded" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone-incoming" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone-missed" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="phone-outgoing" />
                      </li>
                      <li>
                        <FeatherIcon icon="pie-chart" />
                      </li>
                      <li>
                        <FeatherIcon icon="play" />
                      </li>
                      <li>
                        <FeatherIcon icon="play-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="plus" />
                      </li>
                      <li>
                        <FeatherIcon icon="plus-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="plus-square" />
                      </li>
                      <li>
                        <FeatherIcon icon="pocket" />
                      </li>
                      <li>
                        <FeatherIcon icon="power" />
                      </li>
                      <li>
                        <FeatherIcon icon="printer" />
                      </li>
                      <li>
                        <FeatherIcon icon="radio" />
                      </li>
                      <li>
                        <FeatherIcon icon="refresh-ccw" />
                      </li>
                      <li>
                        <FeatherIcon icon="refresh-cw" />
                      </li>
                      <li>
                        <FeatherIcon icon="repeat" />
                      </li>
                      <li>
                        <FeatherIcon icon="rewind" />
                      </li>
                      <li>
                        <FeatherIcon icon="rotate-ccw" />
                      </li>
                      <li>
                        <FeatherIcon icon="rotate-cw" />
                      </li>
                      <li>
                        <FeatherIcon icon="rss" />
                      </li>
                      <li>
                        <FeatherIcon icon="save" />
                      </li>
                      <li>
                        <FeatherIcon icon="scissors" />
                      </li>
                      <li>
                        <FeatherIcon icon="search" />
                      </li>
                      <li>
                        <FeatherIcon icon="send" />
                      </li>
                      <li>
                        <FeatherIcon icon="server" />
                      </li>
                      <li>
                        <FeatherIcon icon="settings" />
                      </li>
                      <li>
                        <FeatherIcon icon="share" />
                      </li>
                      <li>
                        <FeatherIcon icon="share-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="shield" />
                      </li>
                      <li>
                        <FeatherIcon icon="shield-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="shopping-bag" />
                      </li>
                      <li>
                        <FeatherIcon icon="shopping-cart" />
                      </li>
                      <li>
                        <FeatherIcon icon="shuffle" />
                      </li>
                      <li>
                        <FeatherIcon icon="sidebar" />
                      </li>
                      <li>
                        <FeatherIcon icon="skip-back" />
                      </li>
                      <li>
                        <FeatherIcon icon="skip-forward" />
                      </li>
                      <li>
                        <FeatherIcon icon="slack" />
                      </li>
                      <li>
                        <FeatherIcon icon="slash" />
                      </li>
                      <li>
                        <FeatherIcon icon="sliders" />
                      </li>
                      <li>
                        <FeatherIcon icon="smartphone" />
                      </li>
                      <li>
                        <FeatherIcon icon="speaker" />
                      </li>
                      <li>
                        <FeatherIcon icon="square" />
                      </li>
                      <li>
                        <FeatherIcon icon="star" />
                      </li>
                      <li>
                        <FeatherIcon icon="stop-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="sun" />
                      </li>
                      <li>
                        <FeatherIcon icon="sunrise" />
                      </li>
                      <li>
                        <FeatherIcon icon="sunset" />
                      </li>
                      <li>
                        <FeatherIcon icon="tablet" />
                      </li>
                      <li>
                        <FeatherIcon icon="tag" />
                      </li>
                      <li>
                        <FeatherIcon icon="target" />
                      </li>
                      <li>
                        <FeatherIcon icon="terminal" />
                      </li>
                      <li>
                        <FeatherIcon icon="thermometer" />
                      </li>
                      <li>
                        <FeatherIcon icon="thumbs-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="thumbs-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="toggle-left" />
                      </li>
                      <li>
                        <FeatherIcon icon="toggle-right" />
                      </li>
                      <li>
                        <FeatherIcon icon="trash" />
                      </li>
                      <li>
                        <FeatherIcon icon="trash-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="trending-down" />
                      </li>
                      <li>
                        <FeatherIcon icon="trending-up" />
                      </li>
                      <li>
                        <FeatherIcon icon="triangle" />
                      </li>
                      <li>
                        <FeatherIcon icon="truck" />
                      </li>
                      <li>
                        <FeatherIcon icon="tv" />
                      </li>
                      <li>
                        <FeatherIcon icon="twitter" />
                      </li>
                      <li>
                        <FeatherIcon icon="type" />
                      </li>
                      <li>
                        <FeatherIcon icon="umbrella" />
                      </li>
                      <li>
                        <FeatherIcon icon="underline" />
                      </li>
                      <li>
                        <FeatherIcon icon="unlock" />
                      </li>
                      <li>
                        <FeatherIcon icon="upload" />
                      </li>
                      <li>
                        <FeatherIcon icon="upload-cloud" />
                      </li>
                      <li>
                        <FeatherIcon icon="user" />
                      </li>
                      <li>
                        <FeatherIcon icon="user-check" />
                      </li>
                      <li>
                        <FeatherIcon icon="user-minus" />
                      </li>
                      <li>
                        <FeatherIcon icon="user-plus" />
                      </li>
                      <li>
                        <FeatherIcon icon="user-x" />
                      </li>
                      <li>
                        <FeatherIcon icon="users" />
                      </li>
                      <li>
                        <FeatherIcon icon="video" />
                      </li>
                      <li>
                        <FeatherIcon icon="video-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="voicemail" />
                      </li>
                      <li>
                        <FeatherIcon icon="volume" />
                      </li>
                      <li>
                        <FeatherIcon icon="volume-1" />
                      </li>
                      <li>
                        <FeatherIcon icon="volume-2" />
                      </li>
                      <li>
                        <FeatherIcon icon="volume-x" />
                      </li>
                      <li>
                        <FeatherIcon icon="watch" />
                      </li>
                      <li>
                        <FeatherIcon icon="wifi" />
                      </li>
                      <li>
                        <FeatherIcon icon="wifi-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="wind" />
                      </li>
                      <li>
                        <FeatherIcon icon="x" />
                      </li>
                      <li>
                        <FeatherIcon icon="x-circle" />
                      </li>
                      <li>
                        <FeatherIcon icon="x-square" />
                      </li>
                      <li>
                        <FeatherIcon icon="zap" />
                      </li>
                      <li>
                        <FeatherIcon icon="zap-off" />
                      </li>
                      <li>
                        <FeatherIcon icon="zoom-in" />
                      </li>
                      <li>
                        <FeatherIcon icon="zoom-out" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* /Chart */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};
export default FeatherIcons;
